<template>
    <div class="flex items-center cursor-pointer" @click="toggle">
        <div class="flex items-center" style="width: 24px;">
            <radio-checked-icon v-if="isChecked" class="text-blue-500"></radio-checked-icon>
            <radio-unchecked-icon v-else></radio-unchecked-icon>
        </div>
        <div class="ml-3"><slot></slot></div>
    </div>
</template>

<script>
import isEqual from 'lodash/isEqual';

export default {
    props: {
        value: null,
        altValue: null
    },
    components: {
        RadioCheckedIcon: () => import(/* webpackChunkName: "radio-checked-icon" */ '@/icons/RadioChecked.vue'),
        RadioUncheckedIcon: () => import(/* webpackChunkName: "checkbox-outline-icon" */ '@/icons/RadioUnchecked.vue')
    },
    computed: {
        isChecked () {
            return isEqual(this.value, this.altValue);
        }
    },
    methods: {
        toggle () {
            this.$emit('input', this.altValue)
        }
    }
}
</script>
